import { render, staticRenderFns } from "./ManageCalls.vue?vue&type=template&id=85921c1e&scoped=true&"
import script from "./ManageCalls.vue?vue&type=script&lang=js&"
export * from "./ManageCalls.vue?vue&type=script&lang=js&"
import style0 from "./ManageCalls.vue?vue&type=style&index=0&id=85921c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85921c1e",
  null
  
)

export default component.exports